import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="self-destruct"
export default class extends Controller {
  static values = {
    timeoutMs: {type: Number, default: 3000}
  }

  connect() {
    setTimeout(() => {
      this.element.remove()
    }, this.timeoutMsValue)
  }
}
